import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "../../../theme/customTheme";

export const useStyles = makeStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    rowGap: designTokens.spacing[3],
  },
  fieldRow: {
    display: "flex",
    gap: designTokens.spacing[4],
  },
  fieldFlex: {
    flex: 1,
  },
  errorMessage: {
    color: designTokens.semantic.error,
    marginLeft: designTokens.spacing[3],
  },
});
